import { render, staticRenderFns } from "./BookUserCustomCategory.vue?vue&type=template&id=3e46faed&scoped=true"
import script from "./BookUserCustomCategory.vue?vue&type=script&lang=js"
export * from "./BookUserCustomCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e46faed",
  null
  
)

export default component.exports